import React from "react";

const App: React.FC = () => {
  return (
    <div>
      <h3>Welcome to Everest!</h3>
    </div>
  );
};

export default App;
